// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entryId: __t.u64().primaryKey().name("entry_id"),
  containerId: __t.u64().name("container_id"),
  leaseId: __t.u64().name("lease_id"),
  tenant: __t.identity(),
  kind: __t.string(),
  itemKey: __t.string().name("item_key"),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string().name("packed_json"),
  storedAt: __t.timestamp().name("stored_at"),
});
